import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { FormHelperText, Box, Typography, Button } from "@mui/material";
import { CloudUpload } from "@mui/icons-material";
import { StyledFileInput, StyledLabel } from "./StyleInputs";

const FileUploadField = ({ field }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const errorMessage = errors[field.id]?.message;
  const [fileName, setFileName] = useState("");

  return (
    <Box sx={{ mb: 3 }}>
      <StyledLabel required={field.required}>{field.label}</StyledLabel>
      <Controller
        name={field.id}
        control={control}
        defaultValue={null}
        rules={{
          required: field.required ? `${field.label} is required` : false,
          validate: (value) => {
            if (!value)
              return field.required ? `${field.label} is required` : true;

            if (field.maxSize && value.size > field.maxSize) {
              return `File size must be less than ${field.maxSize / 1000000}MB`;
            }

            return true;
          },
        }}
        render={({ field: { onChange, ref } }) => (
          <>
            <StyledFileInput>
              <input
                type="file"
                hidden
                accept={field.accept || "*/*"}
                onChange={(e) => {
                  const file = e.target.files?.[0] || null;
                  onChange(file);
                  setFileName(file ? file.name : "");
                }}
                ref={ref}
                id={`file-upload-${field.id}`}
              />
              <label htmlFor={`file-upload-${field.id}`}>
                <Button
                  component="span"
                  startIcon={<CloudUpload />}
                  sx={{
                    textTransform: "none",
                    fontWeight: 500,
                  }}
                >
                  Upload File
                </Button>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ mt: 1 }}
                >
                  {fileName || "Click to browse"}
                </Typography>
              </label>
            </StyledFileInput>

            {errorMessage && (
              <FormHelperText error>{errorMessage}</FormHelperText>
            )}
          </>
        )}
      />
    </Box>
  );
};

export default FileUploadField;
